"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.runValleyBankCalcAgent = void 0;
/* eslint-disable camelcase */
const calc_agent_1 = require("@finley-technologies/calc-agent");
const common_1 = require("@finley-technologies/common");
const typeguards = __importStar(require("../typeguards"));
const createLoanTapeEvaluators_1 = require("./createLoanTapeEvaluators");
const groupReceivables_1 = require("./groupReceivables");
const Mesh_1 = require("./Mesh");
const valuationTracker_1 = require("./valuationTracker");
const runCalcAgentForLoanAccount = ({ loanAccount, valuationTracker, calcAgentMechanics, loanBalance, isLast, progressCallback, }) => __awaiter(void 0, void 0, void 0, function* () {
    const receivablesPass1 = valuationTracker.getReceivablesForLoanAccount({
        loanAccount,
        useValuation: 'available',
    });
    const [cfToBbbrPass1, cfToBbbrPass2] = (0, calc_agent_1.createPartialProgressCallbacks)({
        progressCallback,
        weights: [1, 1],
    });
    const { borrowingBaseReceivables: pass1Results, } = yield (0, calc_agent_1.creditFacilityToBorrowingBaseReceivablesUsingMechanics)({
        creditFacilityReceivables: receivablesPass1,
        progressCallback: cfToBbbrPass1,
        calcAgentMechanics,
        receivableWaivers: [], // do not use receivable-level eligibility / concentration waivers for valley-bank
    });
    if (isLast) {
        yield cfToBbbrPass2('calc-agent Pass2', 'skipped', 100);
        return {
            borrowingBaseReceivables: valuationTracker.finalizeValuations(pass1Results),
        };
    }
    valuationTracker.updateCurrentValuationRates({
        borrowingBaseReceivables: pass1Results,
        loanAccount,
        loanBalance,
    });
    const receivablesPass2 = valuationTracker.getReceivablesForLoanAccount({
        loanAccount,
        useValuation: 'current',
    });
    const { borrowingBaseReceivables: pass2Results, } = yield (0, calc_agent_1.creditFacilityToBorrowingBaseReceivablesUsingMechanics)({
        creditFacilityReceivables: receivablesPass2,
        calcAgentMechanics,
        progressCallback: cfToBbbrPass2,
        receivableWaivers: [], // do not use receivable-level eligibility / concentration waivers for valley-bank
    });
    return {
        borrowingBaseReceivables: valuationTracker.finalizeValuations(pass2Results),
    };
});
const runCalcAgentForMesh = ({ calcAgentMechanics, loanBalances, maps, mesh, meshReceivables, progressCallback, }) => __awaiter(void 0, void 0, void 0, function* () {
    // for the receivables that are assigned to multiple loan_accounts,
    // we need to split them into multiple receivables.
    // we will run calc-agent for each loan-account seperately
    // and decide the valuation based on the loan-account balance, and
    // the receivable's assignment to the loan-account.
    const [sortProgress, loanAccountProgress] = (0, calc_agent_1.createPartialProgressCallbacks)({
        progressCallback,
        weights: [5, 95],
    });
    // we sort loan accounts to produce deterministic results for the mesh
    // sort by loan balances, loans with lowest balances are handled first.
    yield sortProgress('Sorting loan accounts', 'started', 0);
    const loanAccounts = Array.from(mesh.loanAccounts).sort((a, b) => ((a && loanBalances.get(a)) || 0) - ((b && loanBalances.get(b)) || 0));
    yield sortProgress('Sorting loan accounts', 'Done', 100);
    const valuationTracker = (0, valuationTracker_1.createValuationTracker)({
        meshReceivables,
        maps,
    });
    const loanAccountWeights = new Array(loanAccounts.length).fill(1);
    const loanAccountProgressCallbacks = (0, calc_agent_1.createPartialProgressCallbacks)({
        progressCallback: loanAccountProgress,
        weights: loanAccountWeights,
    });
    const receivables = [];
    for (const [index, loanAccount] of loanAccounts.entries()) {
        const loanBalance = (loanAccount && loanBalances.get(loanAccount)) || 0;
        // eslint-disable-next-line no-await-in-loop
        const { borrowingBaseReceivables } = yield runCalcAgentForLoanAccount({
            valuationTracker,
            loanAccount,
            calcAgentMechanics,
            loanBalance,
            isLast: index === loanAccounts.length - 1,
            progressCallback: loanAccountProgressCallbacks[index],
        });
        borrowingBaseReceivables.forEach((rec) => receivables.push(rec));
    }
    const output = receivables.flat();
    // const debugLoanAccounts = ['9500113728'];
    // const needDebug = debugLoanAccounts.some((account) =>
    //   mesh.loanAccounts.has(account),
    // );
    // if (needDebug) {
    //   const balances: LOAN_BALANCE_FIELDS[] = [];
    //   loanBalances.forEach((balance, account) => {
    //     balances.push({ loanAccountNumber: account, loanBalance: balance });
    //   });
    //   reconcile(output, balances);
    // }
    return output;
});
// given loan tapes and borrowing base mechanics. generates borrowingBaseReceivables
const runValleyBankCalcAgent = ({ reportingDate, calcAgentMechanics: config, loanBalances, receivables, // these can be mixed loan products / loan accounts. But need to include whole meshes.
progressCallback, }) => __awaiter(void 0, void 0, void 0, function* () {
    // generate lookup tables for receivables.
    const [groupReceivablesProgress, creditFacilityReceivablesProgress, parseFormulaProgress, allMeshProgress,] = (0, calc_agent_1.createPartialProgressCallbacks)({
        progressCallback,
        weights: [5, 20, 5, 70],
    });
    const maps = yield (0, groupReceivables_1.groupReceivables)(receivables, groupReceivablesProgress);
    // convert to cfREceivables.
    const { errors, creditFacilityReceivables, } = yield (0, createLoanTapeEvaluators_1.createCreditFacilityReceivables)({
        maps,
        calcAgentMechanics: config,
        reportingDate,
        progressCallback: creditFacilityReceivablesProgress,
    });
    if (errors.length > 0) {
        return {
            errors,
            borrowingBaseReceivables: [],
        };
    }
    yield parseFormulaProgress('Parsing Formulas', 'started', 0);
    const calcAgentMechanics = (0, calc_agent_1.createCalcAgentMechanics)({
        loanTapeMetadata: { reportingDate },
        config,
    });
    yield parseFormulaProgress('Parsing Formulas', 'done', 100);
    // group receivables into meshes.
    const meshes = (0, Mesh_1.generateMeshes)(maps.loanAccountToReceivables);
    const meshWeights = meshes.map((mesh) => mesh.receivables.size * mesh.loanAccounts.size);
    const meshProgressCallbacks = (0, calc_agent_1.createPartialProgressCallbacks)({
        progressCallback: allMeshProgress,
        weights: meshWeights,
    });
    const borrowingBaseReceivables = [];
    for (const [index, mesh] of meshes.entries()) {
        const meshReceivables = creditFacilityReceivables.filter((rec) => mesh.receivables.has(rec.finleyReceivableId));
        // eslint-disable-next-line no-await-in-loop
        yield meshProgressCallbacks[index](`Mesh[ ${index}/${meshes.length} ]`, 'started', 0);
        // @vb: todo propogate errors from runCalcAgentForMesh
        // eslint-disable-next-line no-await-in-loop
        const meshBBR = yield runCalcAgentForMesh({
            loanBalances,
            mesh,
            maps,
            calcAgentMechanics,
            meshReceivables,
            progressCallback: (operation, message, percentage) => __awaiter(void 0, void 0, void 0, function* () {
                yield meshProgressCallbacks[index](`Mesh[ ${index}/${meshes.length} ]: ${operation}`, message, percentage);
            }),
        });
        // eslint-disable-next-line no-await-in-loop
        yield meshProgressCallbacks[index](`Mesh[ ${index + 1}  / ${meshes.length} ]`, 'Done', 100);
        meshBBR.forEach((rec) => {
            const baseFields = rec.baseFields;
            (0, common_1.finleyAssert)(typeguards.hasValleyBankRequiredBaseFields(baseFields), 'Valley Bank Borrowing Base Receivable is missing required base fields.');
            const temp = Object.assign(Object.assign({}, rec), { baseFields });
            if ('sanitizedRow' in temp) {
                delete temp.sanitizedRow;
            }
            borrowingBaseReceivables.push(temp);
        });
    }
    return { borrowingBaseReceivables, errors: [] };
});
exports.runValleyBankCalcAgent = runValleyBankCalcAgent;
//# sourceMappingURL=run.js.map